import React, { useState } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonItem, IonLabel, IonInput, IonTextarea } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import config from '../config'; // Import config

function UserProfile({ user }) {
  const history = useHistory();
  const [description, setDescription] = useState(user?.description || '');
  const [location, setLocation] = useState(user?.location || '');

  const handleUpdate = () => {
    fetch(`${config.API_BASE_URL}/users/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ description, location })
    }).then(() => alert('Profile updated!'));
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{user.username}s Profile</IonTitle>
          <IonButton slot="end" onClick={() => history.push('/')}>Home</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem>
          <IonLabel>Username: {user.username}</IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Description</IonLabel>
          <IonTextarea value={description} onIonChange={e => setDescription(e.target.value)}></IonTextarea>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Location</IonLabel>
          <IonInput value={location} onIonChange={e => setLocation(e.target.value)}></IonInput>
        </IonItem>
        <IonButton expand="block" onClick={handleUpdate}>Update Profile</IonButton>
      </IonContent>
    </IonPage>
  );
}

UserProfile.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    description: PropTypes.string,
    location: PropTypes.string
  }).isRequired
};

export default UserProfile;